import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleCalendarRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22.316 9.68417L16.6318 9.05261L9.68441 9.68417L9.05273 16L9.68429 22.3159L16.0001 23.1053L22.316 22.3159L22.9475 15.8422L22.316 9.68417Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2762 19.4832C11.8041 19.1642 11.4773 18.6985 11.2988 18.0826L12.3947 17.6311C12.4941 18.01 12.6678 18.3037 12.9157 18.5121C13.1621 18.7206 13.4621 18.8232 13.8126 18.8232C14.171 18.8232 14.4789 18.7142 14.7362 18.4963C14.9935 18.2784 15.1231 18.0004 15.1231 17.6642C15.1231 17.32 14.9873 17.0389 14.7157 16.8211C14.4441 16.6033 14.1031 16.4942 13.6957 16.4942H13.0626V15.4095H13.6309C13.9814 15.4095 14.2767 15.3148 14.5167 15.1254C14.7567 14.9359 14.8767 14.6769 14.8767 14.3469C14.8767 14.0533 14.7693 13.8195 14.5547 13.6443C14.34 13.4691 14.0683 13.3807 13.7383 13.3807C13.4162 13.3807 13.1604 13.466 12.9709 13.6381C12.7814 13.8102 12.644 14.0217 12.5573 14.2712L11.4726 13.8196C11.6162 13.4122 11.88 13.0522 12.2667 12.7412C12.6536 12.4302 13.1478 12.2738 13.7478 12.2738C14.1914 12.2738 14.5909 12.3591 14.9447 12.5312C15.2983 12.7033 15.5762 12.9417 15.7767 13.2448C15.9773 13.5495 16.0767 13.8907 16.0767 14.2695C16.0767 14.6564 15.9836 14.9832 15.7973 15.2516C15.6109 15.52 15.3819 15.7252 15.1104 15.869V15.9337C15.4688 16.0837 15.7609 16.3126 15.9914 16.6206C16.2204 16.9285 16.3356 17.2964 16.3356 17.7259C16.3356 18.1554 16.2266 18.539 16.0087 18.8754C15.7908 19.2117 15.4892 19.4769 15.1071 19.6695C14.7235 19.8621 14.2925 19.96 13.814 19.96C13.2599 19.9616 12.7483 19.8021 12.2762 19.4832Z",
			fill: "#1A73E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9996 14.0453L17.8027 14.9153L17.2012 14.0027L19.3596 12.4458H20.187V19.7894H18.9996V14.0453Z",
			fill: "#1A73E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.3159 28L28 22.3159L25.1579 21.0527L22.3159 22.3159L21.0527 25.1579L22.3159 28Z",
			fill: "#EA4335"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.42188 25.1579L9.685 28H22.3166V22.3158H9.685L8.42188 25.1579Z",
			fill: "#34A853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.89468 4C4.84792 4 4 4.84792 4 5.89468V22.3157L6.84208 23.5788L9.68416 22.3157V9.68416H22.3157L23.5788 6.84208L22.3158 4H5.89468Z",
			fill: "#4285F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 22.3158V26.1053C4 27.1522 4.84792 28 5.89468 28H9.68416V22.3158H4Z",
			fill: "#188038"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.3164 9.68414V22.3157H28.0006V9.68414L25.1585 8.42102L22.3164 9.68414Z",
			fill: "#FBBC04"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.0006 9.68416V5.89468C28.0006 4.8478 27.1526 4 26.1059 4H22.3164V9.68416H28.0006Z",
			fill: "#1967D2"
		})
	]
});
export default SvgGoogleCalendarRegularIcon;
